<template>
  <header class="skeleton__header">
    <div class="skeleton__header__title">
      <v-skeleton-loader type="text" />
    </div>
    <div class="skeleton__header__description">
      <v-skeleton-loader type="text" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'SkeletonHeader',
};
</script>

<style lang="scss" scoped>
.skeleton__header {
  margin-bottom: var(--ds-spacing-stack-md);
}

::v-deep {
  .v-skeleton-loader {
    .v-skeleton-loader__bone::after {
      background:
        linear-gradient(
          90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0)
        );
    }

    .v-skeleton-loader__text {
      background:
        linear-gradient(
          90deg,
          rgba(245, 245, 245, 1) 0%,
          rgba(210, 210, 212, 1) 80%
        );
    }
  }

  .skeleton__header {
    &__title {
      .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__text {
        max-width: 40%;
        border-radius: 20px;
        height: 30px;
        margin-bottom: 10px;
      }
    }

    &__description {
      .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__text {
        max-width: 25%;
        border-radius: 20px;
        height: 15px;
      }
    }
  }
}
</style>
